module.exports = __webpack_public_path__ + "static/img/bol.176072b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/bol.svg
// module id = Lqh+
// module chunks = 0